import {
  Component,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { VesselDAO } from '../../../../core/services/dao/vesselDAO';
import { ActivatedRoute, Router } from '@angular/router';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { VesselImageDAO } from '../../../../core/services/dao/vesselImageDAO';
import { VesselImage } from 'anchor-shared/lib/model/entity/vesselImage';
import {
  DomSanitizer,
  Meta,
  SafeHtml,
  SafeResourceUrl,
  Title,
} from '@angular/platform-browser';
import { YouTubeValidationService } from '../../../../core/services/youtube-validation.service';
import { NumberFormatterService } from '../../../../core/services/number.formatter.service';
import { WaterBodyDAO } from '../../../../core/services/dao/waterBodyDAO';
import { EnvironmentalMediaService } from '../../../../core/services/environmental-media.service';
import { OrderVesselImagesByPipe } from '../../../shared/pipes/order-vessel-images-by.pipe';
import { AppLocation } from '../../../../core/models/interface/geo';
import { Subscription } from 'rxjs';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { getExtension } from '../../../../core/pure-functions/upload/image-upload-helper';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { vesselDetailsDescription } from '../../../../core/pure-functions/upload/ng-universal-tags';
import { AppSwiperCarouselImage } from 'anchor-shared/lib/model/interface/carouselImage';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { AuthService } from '../../../../core/services/auth.service';
import { CustomerAccountDialogService } from '../../../shared/dialogs/customer-account-dialog/customer-account-dialog-service';
import { ErrorDialogService } from '../../../shared/errorDialog/errorDialogService';
import { CharterDAO } from '../../../../core/services/dao/charterDAO';
import { buildRouteEnding } from '../../../../core/pure-functions/navigation/buyflow-vessel-route-builder/buyflow-vessel-route-builder';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import * as moment from 'moment';
import { Moment } from 'moment';
import { ProductOfferingDAO } from '../../../../core/services/dao/productOfferingDAO';
import {
  BuyflowProductOffering,
  LineItem,
} from 'anchor-shared/lib/model/interface/buyflowProductOffering';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MobileBookingAvailabilityComponent } from '../mobile-booking-availability/mobile-booking-availability.component';
import { CharterBuyflowHelperService } from '../../../../core/services/charter-buyflow/charter-buyflow-helper-service';
import { DialogsService } from '../../../../core/services/dialog.service';
import { VesselRateCalculationService } from '../../../../core/services/vessel-rate-calculation-service';
import { RateType } from 'anchor-shared/lib/model/enum/vessel-rate-types';
import unitedStates from '../../../../assets/states/united-states';
import { ArrayParsingUtils } from '../../../../core/services/array-parsing-utils';
import * as uuid from 'uuid';
import { CharterType } from 'anchor-shared/lib/model/enum/charter-type';
import { VesselAvailabilityDAO } from '../../../../core/services/dao/VesselAvailabilityDAO';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { termAvailabilityResponse } from 'anchor-shared/lib/model/interface/termAvailabilityResponse';
import { AddOn } from 'anchor-shared/lib/model/entity/addOn';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomerAddOnsDialogComponent } from '../../../shared/dialogs/customer-add-ons-dialog/customer-add-ons-dialog.component';
import {
  getAddOnsTotal,
  getTermCharterDateCount,
} from 'anchor-shared/lib/service/pure-functions/charter-pricing/charter-pricing-helper';
import { selectedProductVesselIdWrapper } from '../../../shared/public-components/request-booking-form/request-booking-form.component';
import { CustomerReviewDAO } from '../../../../core/services/dao/customerReviewDAO';
import { CustomerReviewRatingType } from 'anchor-shared/lib/model/enum/customer-review-rating-type';

@Component({
  selector: 'app-charter-buyflow-vessel-detail',
  templateUrl: './charter-buyflow-vessel-detail.component.html',
  styleUrls: ['./charter-buyflow-vessel-detail.component.scss'],
  providers: [CharterBuyflowHelperService],
})
export class CharterBuyflowVesselDetailComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  vessel: Vessel;
  vesselReviews;
  aggregateReviews;
  overallRating: number;
  vesselImages: VesselImage[];
  carouselItems: AppSwiperCarouselImage[] = [];
  displayYouTubeIFrame = false;
  validatedIFrameLink: SafeResourceUrl;
  features: string[];
  isMobile: boolean;
  waterBodyString = '';
  boatLocation: AppLocation;
  subs: Subscription[] = [];
  isBrowser: boolean;
  resolvedData: any;
  affiliateVanity: string;
  offeringDuration = 4;
  selectedProduct: BuyflowProductOffering;
  pricingSettled: boolean;
  availableOn: Moment = null;
  availableFrom: Moment = null;
  availableTo: Moment = null;
  productsOffered: BuyflowProductOffering[] = [];
  listPrice: string;
  parkingAddressComponents: any;
  parsedDescription: SafeHtml;
  crewCount = 0;
  amenitiesToShow: string[];
  offeredDurations: any[] = [];
  formattedAddress: string = '';

  charterType: CharterType;
  termCharterPricing;
  loadingTermPricing: boolean = true;
  termProducts;
  termDateRangeUnavailable: boolean = false;
  termAddOnsLoading: boolean = false;
  CharterType = CharterType;

  customerAddOnsDialogRef: MatDialogRef<CustomerAddOnsDialogComponent>;

  constructor(
    private route: ActivatedRoute,
    private vesselDAO: VesselDAO,
    private vesselImageDAO: VesselImageDAO,
    private waterBodyDAO: WaterBodyDAO,
    private charterDAO: CharterDAO,
    private youtubeValidator: YouTubeValidationService,
    private numberFormatterService: NumberFormatterService,
    private orderVesselImagesByPipe: OrderVesselImagesByPipe,
    private environmentalMediaService: EnvironmentalMediaService,
    private userDAO: UserDAO,
    private customerReviewDAO: CustomerReviewDAO,
    private vesselAvailabilityDAO: VesselAvailabilityDAO,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: any,
    private meta: Meta,
    private title: Title,
    private router: Router,
    private customerAccountDialogService: CustomerAccountDialogService,
    private errorDialogService: ErrorDialogService,
    private productOfferingDAO: ProductOfferingDAO,
    @Inject(DOCUMENT) private document: any,
    private matBottomSheet: MatBottomSheet,
    private charterBuyflowHelperService: CharterBuyflowHelperService,
    private dialogService: DialogsService,
    private sanitizer: DomSanitizer,
    private calcService: VesselRateCalculationService,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    const breakpointSub = this.breakpointObserver
      .observe(['(min-width: 960px)'])
      .subscribe((state: BreakpointState) => {
        this.isMobile = !state.matches;
      });

    this.resolvedData = this.route.snapshot.data.resolvedData;
    this.vessel = this.resolvedData[0];
    this.initBaseProducts();
    this.vessel.vesselRates.forEach((rate) => {
      if (rate.rateType === 'Crew') {
        this.crewCount++;
      }
    });

    this.getVesselReviews();

    // @ts-ignore
    if (this.vessel.mooringLocation.parkingAddressComponents) {
      this.parkingAddressComponents =
        this.vessel.mooringLocation.parkingAddressComponents;
      const state = unitedStates.find((state) => {
        return state.name === this.parkingAddressComponents.region;
      });

      const abbreviation = state
        ? state.abbreviation
        : this.parkingAddressComponents.region;

      this.formattedAddress = `${this.parkingAddressComponents.city}, ${abbreviation}, ${this.parkingAddressComponents.country}`;
    }

    if (this.vessel.description) {
      this.parsedDescription = this.sanitizer.bypassSecurityTrustHtml(
        this.vessel.description,
      );
    }

    const canonConfig = this.resolvedData[1];

    const vesselImagesSub = this.vesselImageDAO
      .getCroppedByVesselId(this.vessel.id)
      .subscribe((images) => {
        this.vesselImages = this.orderVesselImagesByPipe.transform(
          images,
          'sortOrder',
        );
        this.createCarouselList();
      });
    this.subs.push(vesselImagesSub);

    this.affiliateVanityDetermination();
    const canonical = this.buildCanonicalUrl(canonConfig);
    this.setTags(this.vessel, canonical, canonConfig);
    this.updateCanonical(canonical);

    this.boatLocation = {
      position: {
        lat: this.vessel.mooringLocation.parkingLat,
        lng: this.vessel.mooringLocation.parkingLong,
      },
      addressComponents: [],
      formattedAddress: '',
      vicinity: '',
      markerLatitude: 0,
      markerLongitude: 0,
      zoom: 12,
    };
  }

  @HostListener('window:resize', [])
  onResize() {
    const width = window.innerWidth;
    this.isMobile = width < 500;
  }

  ngOnInit() {
    this.initOauthCheck();
    this.getComponentData();
    this.setYoutubeUI();
    this.findCalendarPrefForDate();
    this.initCharterType();
    if (this.isBrowser) {
      this.availableOn = moment(sessionStorage.getItem('filterDate'));
      const { startDate, endDate } = this.route.snapshot.queryParams;
      this.availableFrom = startDate
        ? moment(startDate)
        : moment(sessionStorage.getItem('filterDateRangeStart'));
      this.availableTo = endDate
        ? moment(endDate)
        : moment(sessionStorage.getItem('filterDateRangeEnd'));
      if (this.availableOn.isValid()) {
        const productSub = this.charterBuyflowHelperService
          .getAvailableProductsForDay(
            this.isBrowser,
            this.availableOn,
            this.vessel,
          )
          .subscribe((res) => {
            this.productsOffered = res.productsOffered;
            this.selectedProduct = res.selectedProduct;
            this.listPrice = res.listPrice;
            this.pricingSettled = true;
          });
        this.subs.push(productSub);
      }

      this.pricingSettled = true;
      if (this.vessel.halfDayListPrice) {
        this.listPrice = `$${this.vessel.halfDayListPrice.toFixed(2)}`;
      }
    }
    if (this.charterType === CharterType.TermCharter) {
      this.getTermCharterPricing();
    }
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  getComponentData(): void {
    this.features = this.numberFormatterService.parseArrayFromJson(
      this.vessel.features,
    );

    this.amenitiesToShow = this.features.slice(0, 9);

    if (
      this.isBrowser &&
      this.vessel.vesselWaterBodyMap &&
      this.vessel.vesselWaterBodyMap.length
    ) {
      const waterBodySub = this.waterBodyDAO
        .buildWaterBodyString(this.vessel.vesselWaterBodyMap[0].waterBodyId)
        .subscribe((waterBody) => {
          if (waterBody.displayName) {
            this.waterBodyString = waterBody.displayName;
          }
        });
      this.subs.push(waterBodySub);
    }
  }

  getVesselReviews() {
    const publicVesselSub = this.customerReviewDAO
      .getPublicVesselReviews(this.vessel.id)
      .subscribe(({ vesselReviews, aggregateReviews }) => {
        this.vesselReviews = vesselReviews;
        this.aggregateReviews = aggregateReviews;

        this.overallRating =
          aggregateReviews.find(
            (x) => x.ratingType === CustomerReviewRatingType.Overall,
          )?.rateAverage || 5;
      });
    this.subs.push(publicVesselSub);
  }

  viewReviewsModal() {
    this.dialogService.VesselReviewsDialog(
      this.vesselReviews,
      this.aggregateReviews,
      this.isMobile,
    );
  }

  setYoutubeUI(): void {
    if (this.vessel.youtubeLink) {
      this.validatedIFrameLink =
        this.youtubeValidator.validateTransformAndSanitizeYouTubeLink(
          this.vessel.youtubeLink,
        );
      this.displayYouTubeIFrame = true;
    }
  }

  findCalendarPrefForDate() {
    let selectedDay;
    if (this.isBrowser) {
      if (sessionStorage.getItem('filterDate')) {
        selectedDay = moment(sessionStorage.getItem('filterDate'));

        let selectedCalendarPreference = this.vessel.calendarPreferences.find(
          (calPref) => {
            return selectedDay.isBetween(calPref.fromDate, calPref.toDate);
          },
        );
        if (selectedCalendarPreference) {
          const productSub = this.productOfferingDAO
            .findByVesselPreferencesIdForBuyflow(
              this.vessel.id,
              this.vessel.vesselAvailabilityPreferences.id,
            )
            .subscribe((productOfferings) => {
              let hasHalfDayProduct = false;
              productOfferings.forEach((offering) => {
                // @ts-ignore
                if (offering && offering.duration === 4 && offering.active) {
                  hasHalfDayProduct = true;
                }
              });
              if (!hasHalfDayProduct) {
                this.offeringDuration = 8;
              }
            });
          this.subs.push(productSub);
        }
      }
    }
    this.setOfferingDuration();
  }

  setOfferingDuration() {
    if (
      !this.vessel.halfDayOriginalListPrice &&
      this.vessel.fullDayOriginalListPrice
    ) {
      this.offeringDuration = 8;
    }
  }

  getSelectedProductFromSessionStorage(): BuyflowProductOffering {
    let selectedProduct: BuyflowProductOffering;
    if (this.isBrowser) {
      if (
        sessionStorage.getItem(selectedProductVesselIdWrapper(this.vessel.id))
      ) {
        console.log('its in session storage');
        selectedProduct = JSON.parse(
          sessionStorage.getItem(
            selectedProductVesselIdWrapper(this.vessel.id),
          ),
        );
      }
    }
    console.log({ selectedProduct });
    return selectedProduct;
  }

  openBottomSheet() {
    const bottomSheetSub = this.matBottomSheet
      .open(MobileBookingAvailabilityComponent, {
        data: {
          products: this.vessel.activeBuyflowProducts,
          isDateSelected: this.availableOn && this.availableOn.isValid(),
          availableOn: this.availableOn,
          availableFrom: this.availableFrom,
          availableTo: this.availableTo,
          selectedProduct: this.selectedProduct,
          vessel: this.vessel,
          vesselPrefs: this.vessel.vesselAvailabilityPreferences,
          listPrice: this.listPrice,
          charterType: this.charterType,
          termCharterPricing: this.termCharterPricing,
          termDateRangeUnavailable: this.termDateRangeUnavailable,
        },
      })
      .afterDismissed()
      .subscribe(
        ({
          continueToBooking,
          charterType,
          availableFrom,
          availableTo,
          termCharterPricing,
          requiredAddOns,
          ...rest
        }) => {
          if (!continueToBooking) {
            return;
          }
          this.charterType = charterType;
          this.availableFrom = availableFrom;
          this.availableTo = availableTo;
          this.selectedProduct = this.getSelectedProductFromSessionStorage();

          if (requiredAddOns) {
            this.selectedProduct.requiredAddOns = requiredAddOns;
          }
          if (continueToBooking && charterType === CharterType.TermCharter) {
            if (termCharterPricing) {
              this.termCharterPricing = termCharterPricing;
              if (!this.termCharterPricing.optionalAddOns.length) {
                this.termAddOnsLoading = true;
                this.getTermCharterOptions();
              }
            } else {
              this.getTermCharterPricing();
            }
            this.openAddOnsModal();
          } else if (
            continueToBooking &&
            this.selectedProduct.optionalAddOns.length
          ) {
            this.openAddOnsModal();
          } else if (continueToBooking) {
            this.navToBooking();
          }
        },
      );

    this.subs.push(bottomSheetSub);
  }

  openAddOnsModal() {
    if (
      (this.charterType === CharterType.TermCharter &&
        (this.termCharterPricing?.optionalAddOns?.length ||
          this.termAddOnsLoading)) ||
      (this.charterType === CharterType.DayCharter &&
        this.selectedProduct.optionalAddOns.length)
    ) {
      const addOns: AddOn[] =
        this.charterType === CharterType.DayCharter &&
        !this.vessel.vesselIntegration
          ? this.selectedProduct.optionalAddOns
          : this.termCharterPricing.optionalAddOns;
      const charterBasePrice =
        this.charterType === CharterType.DayCharter
          ? parseInt(this.listPrice.replace('$', ''), 10)
          : this.termCharterPricing.baseRate;
      const requiredAddOnsTotal =
        this.charterType === CharterType.DayCharter
          ? getAddOnsTotal(
              this.selectedProduct.requiredAddOns,
              'required',
              true,
            ) // fix this
          : this.termCharterPricing.requiredAddOns;
      const dialogRef = this.dialogService.CustomerAddOnsDialog(
        addOns,
        charterBasePrice,
        requiredAddOnsTotal,
        this.availableFrom,
        this.availableTo,
        this.selectedProduct.duration,
        this.isMobile,
        this.termAddOnsLoading,
      );

      dialogRef.afterClosed().subscribe((selectedAddOns) => {
        if (selectedAddOns) {
          if (this.charterType === CharterType.TermCharter) {
            this.termCharterPricing.optionalAddOns = selectedAddOns;
            sessionStorage.setItem(
              'termPricing',
              JSON.stringify(this.termCharterPricing),
            );
          } else {
            sessionStorage.setItem(
              'addOns',
              JSON.stringify([
                ...selectedAddOns,
                ...this.selectedProduct.requiredAddOns,
              ]),
            );
          }
          this.navToBooking();
        }
      });
    } else {
      this.navToBooking();
    }
  }

  private createCarouselList() {
    this.vesselImages.forEach((item) => {
      this.carouselItems.push({
        swiperImageUrl: this.environmentalMediaService.buildVesselImageURL(
          item.url,
        ),
        getSwiperImageUrl(): string {
          return this.swiperImageUrl;
        },
      });
    });
  }

  private setTags(
    vessel: Vessel,
    canonical: string,
    canonConfig: { affiliatePresent: boolean },
  ): void {
    const title = `Rent this ${vessel.lengthFt}\' ${vessel.make} on Anchor`;
    this.title.setTitle(title);
    this.meta.addTag({
      property: 'description',
      content: vesselDetailsDescription,
    });

    if (canonConfig && canonConfig.affiliatePresent) {
      this.meta.addTag({
        name: 'robots',
        content: 'noindex',
      });

      this.updateCanonical(
        `/vessels/yacht-and-boat-rentals/${this.route.snapshot.params.affiliate}/`,
      );
    }

    // twitter
    this.meta.addTag({
      property: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.addTag({
      property: 'twitter:title',
      content: title,
    });
    this.meta.addTag({
      property: 'twitter:description',
      content: vesselDetailsDescription,
    });
    this.meta.addTag({
      property: 'twitter:image',
      content: vessel.primaryPhotoAbsPath,
    });

    // object graph
    this.meta.addTag({
      property: 'og:site_name',
      content: 'Anchor | Charter Vessels',
    });
    this.meta.addTag({
      property: 'og:locale',
      content: 'en_US',
    });
    this.meta.addTag({
      property: 'og:title',
      content: title,
    });
    this.meta.addTag({
      property: 'og:type',
      content: 'anchor:project',
    });
    this.meta.addTag({
      property: 'og:description',
      content: vesselDetailsDescription,
    });
    this.meta.addTag({
      property: 'og:url',
      content: canonical,
    });
    this.meta.addTag({
      property: 'og:image',
      content: vessel.primaryPhotoAbsPath,
    });
    this.meta.addTag({
      property: 'og:image:type',
      content: 'image/' + getExtension(vessel.primaryPhotoAbsPath),
    });
  }

  private initOauthCheck(): void {
    if (this.isBrowser) {
      const code = this.route.snapshot.queryParams.code;
      if (code) {
        const googleTokenSub = this.authService
          .getGoogleToken(code)
          .subscribe((tokens) => {
            const googleUserInfoSub = this.authService
              .getGoogleUserInfo(tokens)
              .subscribe((userInfo) => {
                const findGoogleUserSub = this.userDAO
                  .findUserByGoogleId(userInfo.id)
                  .subscribe((foundUser) => {
                    if (foundUser && (foundUser.user || foundUser.id)) {
                      const googleAuthSub = this.authService
                        .googleLogin(
                          tokens,
                          foundUser && foundUser.user
                            ? foundUser.user.email
                            : foundUser.email,
                        )
                        .subscribe((res) => {
                          this.navToBooking();
                        });
                      this.subs.push(googleAuthSub);
                    } else {
                      const createGoogleSub = this.authService
                        .createGoogleUser(tokens)
                        .subscribe(
                          (res) => {
                            this.customerOAuthDialog(tokens, res.email, res.id);
                          },
                          (createError) => {
                            // todo - add a login link in here???
                            const sub = this.errorDialogService
                              .open(
                                createError.error.title,
                                createError.error.message,
                              )
                              .subscribe((completed) => {});
                            this.subs.push(sub);
                          },
                        );
                      this.subs.push(createGoogleSub);
                    }
                  });
                this.subs.push(findGoogleUserSub);
              });
            this.subs.push(googleUserInfoSub);
          });
        this.subs.push(googleTokenSub);
      }
    }
  }

  private navToBooking(): void {
    setTimeout(() => {
      if (this.affiliateVanity) {
        this.router.navigate(
          [
            'customer/booking/' + this.affiliateVanity + '/' + this.vessel.id,
            +'/' + uuid.v4(),
          ],
          {
            queryParams: { charterType: this.charterType },
          },
        );
      } else {
        this.router.navigate(
          ['customer/booking/' + this.vessel.id + '/' + uuid.v4()],
          {
            queryParams: { charterType: this.charterType },
          },
        );
      }
    }, 1200);
  }

  private customerOAuthDialog(
    tokens: any,
    userEmail: string,
    userId: number,
  ): void {
    const googleAuthSub = this.authService
      .googleLogin(tokens, userEmail)
      .subscribe((res) => {
        this.customerAccountDialogService
          .open(userId, this.vessel.id, true)
          .subscribe((authSuccessful) => {
            if (authSuccessful) {
              const charterUpdateSub = this.charterDAO
                .updateExistingChartersForNewUser(userId)
                .subscribe((data) => {});
              this.subs.push(charterUpdateSub);
              this.navToBooking();
            } else {
              console.log('not happening');
            }
          });
      });
    this.subs.push(googleAuthSub);
  }

  private affiliateVanityDetermination(): void {
    this.affiliateVanity = this.route.snapshot.params.affiliateVanity;
    if (!this.affiliateVanity) {
      this.affiliateVanity = this.route.snapshot.queryParams.affiliate;
    }
  }

  private updateCanonical(url: string): void {
    const head = this.document.getElementsByTagName('head')[0];
    let element: HTMLLinkElement =
      this.document.querySelector(`link[rel='canonical']`) || null;
    if (element == null) {
      element = this.document.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel', 'canonical');
    element.setAttribute('href', url);
  }

  private buildCanonicalUrl(canonConfig: {
    affiliatePresent: boolean;
  }): string {
    const routeStart =
      this.environmentalMediaService.getClientBaseURL() +
      'vessels/yacht-and-boat-rentals/';
    let canonical: string;
    if (canonConfig && canonConfig.affiliatePresent) {
      canonical =
        routeStart + this.affiliateVanity + '/' + buildRouteEnding(this.vessel);
    } else {
      canonical = routeStart + buildRouteEnding(this.vessel);
    }
    return canonical;
  }

  showAmenities() {
    const amenitiesSub = this.dialogService
      .AmenitiesDialog(this.vessel, this.isMobile)
      .subscribe();
    this.subs.push(amenitiesSub);
  }

  showDescription() {
    const dialogSub = this.dialogService
      .BookingDescriptionDialog(this.vessel, this.isMobile)
      .subscribe();
    this.subs.push(dialogSub);
  }

  openBoatRulesModal() {
    const dialogSub = this.dialogService
      .boatRulesDialog(
        this.vessel.instructionsAndRules,
        this.isMobile,
        this.charterType,
      )
      .subscribe();
    this.subs.push(dialogSub);
  }

  openCancellationDialog() {
    const dialogSub = this.dialogService
      .buyflowCancellationPolicyDialog(this.isMobile, this.charterType)
      .subscribe();
    this.subs.push(dialogSub);
  }

  openDepositDialog() {
    const dialogSub = this.dialogService
      .buyflowDepositDialog(
        this.vessel.depositAmount,
        this.isMobile,
        this.charterType,
      )
      .subscribe();
    this.subs.push(dialogSub);
  }

  productsLoaded(products: BuyflowProductOffering[]) {
    this.productsOffered = products;

    this.productsOffered.forEach((product) => {
      product.totalPrice = this.getProductTotal(product);
    });
  }

  private getProductTotal(product: BuyflowProductOffering): number {
    if (product) {
      return this.getVesselRatePriceAdjustedTotal(product.lineItems);
    }
  }

  getVesselRatePriceAdjustedTotal(lineItem: LineItem[]): number {
    return this.calcService.getVesselRatePriceAdjustedTotal(lineItem);
  }

  private initBaseProducts() {
    this.offeredDurations = [
      {
        duration: 4,
        totalPrice: 0,
      },
      {
        duration: 8,
        totalPrice: 0,
      },
    ];

    if (this.vessel.vesselAvailabilityPreferences.allows3hours) {
      this.offeredDurations.push({
        duration: 3,
        totalPrice: 0,
      });
    }

    if (this.vessel.vesselAvailabilityPreferences.allows567Hours) {
      this.offeredDurations.push(
        {
          duration: 5,
          totalPrice: 0,
        },
        {
          duration: 6,
          totalPrice: 0,
        },
        {
          duration: 7,
          totalPrice: 0,
        },
      );
    }

    if (this.vessel.vesselAvailabilityPreferences.allows910Hours) {
      this.offeredDurations.push(
        {
          duration: 9,
          totalPrice: 0,
        },
        {
          duration: 10,
          totalPrice: 0,
        },
      );
    }

    this.offeredDurations.sort(function (a, b) {
      return a.duration - b.duration;
    });

    this.offeredDurations.forEach((duration) => {
      duration.totalPrice = this.calcService.totalBaseCostForRates(
        this.vessel.vesselRates,
        duration.duration,
        duration.duration,
      );
    });
  }

  updateTermCharterDates({ availableFrom, availableTo }) {
    this.availableFrom = availableFrom;
    this.availableTo = availableTo;

    this.getTermCharterPricing();
  }

  getTermCharterPricing() {
    const startDate = this.availableFrom?.format('YYYY-MM-DD');
    const endDate = this.availableTo?.format('YYYY-MM-DD');
    this.loadingTermPricing = true;

    this.vesselAvailabilityDAO
      .getTermCharterPricing(
        this.vessel.id,
        startDate || null,
        endDate || null,
        false,
      )
      .subscribe((termPricingResponse) => {
        if (this.availableFrom?.isValid() && this.availableTo?.isAfter()) {
          this.getTermCharterOptions();
        }
        this.termCharterPricing = termPricingResponse || {};
        this.termDateRangeUnavailable = !Object.keys(this.termCharterPricing)
          .length;
        this.loadingTermPricing = false;
        if (!termPricingResponse) return;

        const {
          termPricePerDay = 0,
          baseRate,
          requiredDateRange,
        } = termPricingResponse;
        const termDailyPrice = requiredDateRange
          ? baseRate / getTermCharterDateCount(startDate, endDate)
          : termPricePerDay;

        this.termProducts = [
          {
            duration: '3 day / 2 night',
            totalPrice: termDailyPrice * 2,
          },
          {
            duration: '4 day / 3 night',
            totalPrice: termDailyPrice * 3,
          },
          {
            duration: '5 day / 4 night',
            totalPrice: termDailyPrice * 4,
          },
          {
            duration: '6 day / 5 night',
            totalPrice: termDailyPrice * 5,
          },
          {
            duration: '7 day / 6 night',
            totalPrice: termDailyPrice * 6,
          },
          {
            duration: '8 day / 7 night',
            totalPrice: termDailyPrice * 7,
          },
        ];
      });
  }

  getTermCharterOptions() {
    if (this.isBrowser) {
      this.vesselAvailabilityDAO
        .getTermCharterOptions(
          this.vessel.id,
          this.availableFrom?.format('YYYY-MM-DD') || null,
          this.availableTo?.format('YYYY-MM-DD') || null,
        )
        .subscribe(({ optionalAddOns }) => {
          this.termCharterPricing.optionalAddOns = optionalAddOns;
          this.termAddOnsLoading = false;
          // provide data to add ons modal
          if (
            this.customerAddOnsDialogRef &&
            this.customerAddOnsDialogRef.componentInstance?.data
          ) {
            this.customerAddOnsDialogRef.componentInstance.data = {
              addOns: optionalAddOns,
              loading: false,
            };
          }
        });
    }
  }

  updateCharterType(type: CharterType) {
    this.charterType = type;
    this.getTermCharterPricing();
  }

  initCharterType() {
    const defaultType = CharterType.DayCharter;
    const queryType = this.route.snapshot.queryParams.charterType;
    const vesselTermCharter = this.vessel.termCharter;
    const vesselDayCharter = this.vessel.dayCharter;

    if (vesselDayCharter && !vesselTermCharter) {
      this.charterType = CharterType.DayCharter;
    } else if (!vesselDayCharter && vesselTermCharter) {
      this.charterType = CharterType.TermCharter;
    } else if (
      queryType?.toLowerCase() === CharterType.TermCharter.toLowerCase() &&
      vesselTermCharter
    ) {
      this.charterType = CharterType.TermCharter;
    } else if (
      queryType?.toLowerCase() === CharterType.DayCharter.toLowerCase() &&
      vesselDayCharter
    ) {
      this.charterType = CharterType.DayCharter;
    } else if (this.availableOn && vesselDayCharter) {
      this.charterType = CharterType.DayCharter;
    } else if (this.availableFrom && this.availableTo && vesselTermCharter) {
      this.charterType = CharterType.TermCharter;
    } else {
      this.charterType = defaultType;
    }

    if (this.charterType === CharterType.TermCharter) {
      this.termAddOnsLoading = true;
    }

    if (this.route.snapshot.queryParams.charterType !== this.charterType) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          charterType: this.charterType,
        },
        queryParamsHandling: 'merge',
      });
    }
  }

  showSingleBookingTab() {
    return (
      (this.vessel.termCharter && !this.vessel.dayCharter) ||
      (!this.vessel.termCharter && this.vessel.dayCharter)
    );
  }

  getDayCharterProductsToDisplay() {
    return this.productsOffered.length > 0
      ? this.productsOffered
      : this.offeredDurations;
  }
}
